<template>
  <div class="page-container">
    <main class="main-content">
      <div class="page-inner-box">
        <div class="agreement-container">
          <h1 class="agreement-title">{{ title }}</h1>
          <div v-loading="loading" class="agreement-content" v-html="content"></div>
          <div v-if="!loading && !content" class="empty-tip">
            <p>暂无内容</p>
          </div>
        </div>
      </div>
    </main>
  </div>
</template>

<script>
import { getAgreementDetail } from '@/api/agreementApi'

const TITLE_MAP = {
  user_agreement: '用户协议',
  privacy_policy: '隐私政策',
  copyright_statement: '版权声明',
  legal_statement: '法律声明',
  disclaimer: '免责条款',
  social_responsibility: '社会责任',
  market_cooperation: '市场合作'
}

export default {
  name: 'AgreementPage',
  data() {
    return {
      loading: false,
      content: '',
      title: ''
    }
  },
  watch: {
    '$route.params.docType': {
      handler(newVal) {
        if (newVal) this.fetchContent(newVal)
      },
      immediate: false
    }
  },
  created() {
    const docType = this.$route.params.docType
    if (docType) this.fetchContent(docType)
  },
  methods: {
    async fetchContent(docType) {
      this.title = TITLE_MAP[docType] || '协议详情'
      this.loading = true
      try {
        const res = await getAgreementDetail(docType)
        if (res && res.code === 200 && res.data) {
          this.content = res.data.content || ''
        }
      } catch (err) {
        console.error('获取协议内容失败', err)
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<style scoped lang="scss">
.page-container {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  background-color: #f5f7fa;
}

.main-content {
  flex: 1;
  padding-top: 20px;
  padding-bottom: 40px;
}

.agreement-container {
  max-width: 1100px;
  margin: 0 auto;
  background: #fff;
  border-radius: 8px;
  padding: 40px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  min-height: calc(100vh - 200px);
}

.agreement-title {
  font-size: 28px;
  font-weight: 600;
  color: #303133;
  margin: 0 0 30px;
  text-align: center;
}

.agreement-content {
  font-size: 15px;
  line-height: 1.8;
  color: #606266;
  min-height: 200px;

  h2 {
    font-size: 22px;
    font-weight: 600;
    color: #303133;
    margin: 24px 0 16px;
  }

  h3 {
    font-size: 18px;
    font-weight: 600;
    color: #303133;
    margin: 20px 0 12px;
  }

  p {
    margin: 8px 0;
  }
}

.empty-tip {
  text-align: center;
  color: #909399;
  padding: 40px 0;
}
</style>
